module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TSU8x2/tc-custom/9781685506520.jpg?1718079091753",
      "alt": "This image is the cover for the book The Dragon's Prisoner"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Dragon's Prisoner\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Stealing from a dragon is bad, getting caught is worse."), _c('br'), _c('br'), _vm._v("Kasper Cobalt is a thief who wants to quit, but his boss forces him to do one last job. He has, of course, heard of dragons, but he isn’t sure he believes in them until he’s standing in front of a guy who breathes smoke and has weird eyes."), _c('br'), _c('br'), _vm._v("Saxon the Sinful is bored out of his mind. Running a jewelry store on Dragon Row should be pleasing. He is, after all, surrounded by gold and gemstones. But he’s also surrounded by humans, and one of them has the audacity to try to steal from him."), _c('br'), _c('br'), _vm._v("After having caught Kasper, Saxon locks him up in his basement. He should kill him, and he might, but first he’ll feed him. He looks hungry. Kasper can’t hang around and play dragon’s prisoner even though Saxon takes great care of him. His boss will kill him if he doesn’t finish the job. Kasper is reluctant to betray Saxon, but a thief and a dragon can never have a happily ever after, can they?"), _c('br'), _c('br'), _vm._v("NOTE: "), _c('i', [_vm._v("The Dragon’s Prisoner")]), _vm._v(" takes place on the same street as "), _c('i', [_vm._v("The Book Dragon’s Lair")]), _vm._v(" and "), _c('i', [_vm._v("Mated to the Fire Dragon")]), _vm._v(" but can be read as a standalone story.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Holly Day\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0